import { Button, Col, Container, Form, Row, Table } from "react-bootstrap";
import ServicoList from "./ServicoList";
import { ServicosService } from "../../../services/api/Servicos/ServicosService"
import { useEffect, useState } from "react";
import ModalSimNao from "../../../components/ModalSimNao";
import Loading from "../../../components/Loader/Loading";
import PaginacaoLinks from "../../../components/Paginacao/PaginacaoLinks";
import ConfiguracoesSistemaPrincipal from "../ConfiguracoesSistemaPrincipal";
import { usePermissoes } from "../../../hooks/usePermissoes";
import PermissoesComponent from "../../../components/PermissaoComponent";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlusCircle } from "@fortawesome/free-solid-svg-icons";

const Servicos = () => {

    const [paginacao, setPaginacao] = useState({
        currentPage: null,
        totalPages: null,
        nextPage: null,
        prevPage: null

    })

    const [showModalSN, setShowModalSN] = useState(false)
    const [idDelete, setIdDelete] = useState(null)
    const [search, setSearch] = useState('')
    const [timeDelay, setTimeDelay] = useState(null)
    const [isLoading, setIsloading] = useState(true)
    const { listPermissoes, isLoadingPerm } = usePermissoes([
        { secoesId: 9, acoesId: 1 },
        { secoesId: 9, acoesId: 2 },
        { secoesId: 9, acoesId: 3 },
        { secoesId: 9, acoesId: 4 }
    ])

    const fecthServicos = async () => {
        setIsloading(true);
        const res = await ServicosService.getAll(search)
        //console.log(res)
        if (res != undefined) {
            const data = res.data;
            setServicos(data)
            setPaginacao({
                currentPage: res.meta.current_page,
                totalPages: Math.ceil(res.meta.total / res.meta.per_page),
                nextPage: (res.meta.current_page + 1),
                prevPage: (res.meta.current_page - 1)
            })
        }
        setIsloading(false);
    }

    const [servicos, setServicos] = useState([])

    useEffect(() => {
        fecthServicos()
    }, [])



    const handleCloseModalSn = () => {
        setShowModalSN(false)
        setIdDelete(null)
    }

    const handleDelete = (idCliente) => {
        setIdDelete(idCliente)
        setShowModalSN(true)
    }

    const handleConfirmDelete = async () => {
        const data = await ServicosService.deleteById(idDelete)
        fecthServicos()
        // console.log(data)
        setIdDelete(null)
        setShowModalSN(false)
    }
    const onClickPage = async (page) => {
        await fecthServicos(page)
    }

    const handleChangeBusca = (e) => {

        clearTimeout(timeDelay)

        setSearch(e.target.value)

        let time = setTimeout(function () {

            if (e.target.value.length >= 3) {
                fecthServicos()

            } else {
                fecthServicos()
            }

        }, 300)
        setTimeDelay(time);




    }
    return (

        <>

            <ConfiguracoesSistemaPrincipal>
                <h3>Serviços
                    <Button variant="success" size="sm" style={{ marginLeft: '15px' }} href="/admin/configuracoes/servicos/cadEdit"><FontAwesomeIcon icon={faPlusCircle}/> Adicionar</Button>
                </h3>
                <hr></hr>




                {(isLoading) ? <Loading /> : (
                    <>
                        {(!listPermissoes?.ver && !isLoadingPerm) ? (<PermissoesComponent showMsg={true}></PermissoesComponent>) : (
                            <>


                                <Row style={{ flexDirection: 'row-reverse' }}>
                                    <Col xs={12} md={4}>
                                        <Form.Control type="text" placeholder="Buscar  serviço" size="sm" onChange={(e) => handleChangeBusca(e)} />
                                    </Col>
                                </Row>


                                {(servicos.length > 0) ? (
                                    <>
                                        <Table striped  hover size="sm" style={{ marginTop: '15px' }}>
                                            <thead>
                                                <tr>
                                                    <th>Cod.</th>
                                                    <th>Nome</th>
                                                    <th>Valor</th>
                                                    <th></th>
                                                    <th></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <ServicoList listPermissoes={listPermissoes} listServico={servicos} fecthServicos={fecthServicos} handleDelete={handleDelete} />
                                            </tbody>
                                        </Table>

                                        <PaginacaoLinks totalPages={paginacao?.totalPages}
                                            currentPage={paginacao?.current_page}
                                            onClickPage={onClickPage}
                                        ></PaginacaoLinks>
                                    </>

                                ) : <div className="alert alert-warning text-center">Sem usuários registrados</div>}
                                '
                            </>)}
                    </>)}





                <ModalSimNao show={showModalSN} handleClose={() => setShowModalSN(false)} handleConfirm={() => handleConfirmDelete()}>Tem certeza que deseja excluir este cliente?</ModalSimNao>
            </ConfiguracoesSistemaPrincipal>

        </>


    )
}

export default Servicos;